import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

// Token storage key. Tokens are also set as httpOnly cookies for backwards
// compatibility, but on cross-origin production deployments many browsers
// silently block the cookie ("third-party cookie") — so we ALWAYS also
// send the token as a Bearer header from localStorage when present.
const TOKEN_KEY = "im_access_token";

export const setAuthToken = (token) => {
    if (token) localStorage.setItem(TOKEN_KEY, token);
    else localStorage.removeItem(TOKEN_KEY);
};
export const getAuthToken = () => localStorage.getItem(TOKEN_KEY) || null;

const api = axios.create({
    baseURL: API_BASE,
    withCredentials: true,
});

// Attach Bearer header from localStorage on every request — works even if
// the browser drops the auth cookie because of third-party-cookie blocking.
api.interceptors.request.use((config) => {
    const t = getAuthToken();
    if (t) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${t}`;
    }
    return config;
});

// Auto-clear the saved token when the server rejects it.
api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err.response?.status === 401) {
            const url = err.config?.url || "";
            // Don't wipe the token on /auth/login or /auth/me probing —
            // those calls intentionally test creds.
            if (!url.startsWith("/auth/")) setAuthToken(null);
        }
        return Promise.reject(err);
    },
);

export function formatError(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) =>
                e && typeof e.msg === "string" ? e.msg : JSON.stringify(e),
            )
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}

export default api;
